import { Link } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import { useSettings } from '../../store/settingsStore';

export default function ServiceBanner() {
  const { t, language } = useI18n();
  const { serviceMarqueeEnabled, serviceMarqueeItems } = useSettings();
  const items = serviceMarqueeItems
    .filter((item) => item.enabled)
    .map((item) => ({ ...item, label: language === 'en' ? (item.labelEn || item.labelEs) : (item.labelEs || item.labelEn) }))
    .filter((item) => item.label.trim());
  const linkTo = (item: { link: string }) => item.link.trim() || '/services';

  if (!serviceMarqueeEnabled || items.length === 0) return null;

  return (
    <div className="deals-banner deals-banner-slow deals-banner-services relative" role="marquee" aria-label={t('banner_services_aria')}>
      <div className="deals-banner-track" style={{ animationDuration: '120s' }}>
        {[0, 1, 2, 3].map((copy) => (
          <span key={copy} className="contents" aria-hidden={copy > 0}>
            {items.map((item) => (
              <Link key={`${copy}-${item.id}`} to={linkTo(item)} className={`deals-banner-item${item.highlighted ? ' banner-title-item' : ''}`}>
                {item.emoji && <span className="h-4 w-4 shrink-0 text-brand" aria-hidden="true">{item.emoji}</span>}
                <span>{item.label}</span>
                <span className="deal-sep">|</span>
              </Link>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}